import { Label, RadioGroupItem } from '@shared/shared-shadcn-ui';
import { cn } from '@shared/shared-utils';
import { ReactNode } from 'react';

type Properties = {
  label: ReactNode;
  value: string;
  className?: string;
};

const FormRadioButton = ({ label, value, className }: Properties) => {
  return (
    <div className={cn('flex items-start gap-x-4', className)}>
      <RadioGroupItem
        className="w-[35px] h-[35px] mt-[6px] [&>span>svg]:data-[state=checked]:w-[25px] [&>span>svg]:data-[state=checked]:h-[25px]"
        value={value}
        id={value}
      />
      <Label htmlFor={value} className="text-[#3D4543] text-[32px] font-bold cursor-pointer">{label}</Label>
    </div>
  );
};

export { FormRadioButton };
